import { useTranslation } from "react-i18next";

import Button from "features/components/Button";
import Dialog from "features/components/Dialog";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SamsaraAPIKeyGuide = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={t("superadmin:connections.detail.api_key_guide.title")}
      showCloseIcon
      fullWidth
      maxWidth="sm"
      actions={
        <Button
          label={t("common:close")}
          color="primary"
          size="small"
          onClick={onClose}
          testId="samsara-api-key-guide-close"
        />
      }
      testId="samsara-api-key-guide"
    >
      <div className="flex flex-col gap-3 text-sm text-gray-700">
        <p>{t("superadmin:connections.detail.api_key_guide.intro")}</p>
        <ol className="flex flex-col gap-1 list-decimal pl-5">
          <li>
            {t("superadmin:connections.detail.api_key_guide.steps.log_in")}
          </li>
          <li>
            {t("superadmin:connections.detail.api_key_guide.steps.settings")}
          </li>
          <li>
            {t("superadmin:connections.detail.api_key_guide.steps.api_tokens")}
          </li>
          <li>
            {t("superadmin:connections.detail.api_key_guide.steps.add_token")}
          </li>
          <li>
            {t("superadmin:connections.detail.api_key_guide.steps.configure")}
            <ul className="mt-1 flex flex-col gap-1 list-disc pl-5">
              <li>
                {t("superadmin:connections.detail.api_key_guide.settings.name")}
              </li>
              <li>
                {t(
                  "superadmin:connections.detail.api_key_guide.settings.tag_access"
                )}
              </li>
              <li>
                {t(
                  "superadmin:connections.detail.api_key_guide.settings.scopes"
                )}
              </li>
            </ul>
          </li>
          <li>{t("superadmin:connections.detail.api_key_guide.steps.save")}</li>
          <li>{t("superadmin:connections.detail.api_key_guide.steps.copy")}</li>
        </ol>
        <p>{t("superadmin:connections.detail.api_key_guide.outro")}</p>
      </div>
    </Dialog>
  );
};

export default SamsaraAPIKeyGuide;
